import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Stream from 'flarum/common/utils/Stream';
export default class DiscussionPageState {
  constructor() {
    _defineProperty(this, "selectedPostsToMove", void 0);
    this.selectedPostsToMove = Stream([]);
  }
  push(postId) {
    this.selectedPostsToMove([...this.selectedPostsToMove(), postId]);
  }
  remove(postId) {
    this.selectedPostsToMove(this.selectedPostsToMove().filter(id => id !== postId));
  }
  has(postId) {
    return this.selectedPostsToMove().includes(postId);
  }
}
flarum.reg.add('sycho-move-posts', 'forum/states/DiscussionPageState', DiscussionPageState);